// Components
// Utils
import { hourMinuteToSecond, secondToHourMinute } from 'utils/timeConverter';
import { EReservationPeriodType } from '@timeedit/types/lib/enums';
import { TEDrawerSection, TEInput } from '@timeedit/ui-components';
import { Space } from '@timeedit/ui-components/antd';
// Types
import type { IProps } from './sections.interface';
// Styles
import './ReservationPeriod.scss';

const ReservationPeriod = ({ timeRule, onChange }: IProps) => {
  return (
    <TEDrawerSection label="Reservation Period">
      <div className="section-wrapper">
        <Space direction="vertical">
          <TEInput.Select
            label="Reservation period #1"
            tooltip="Reservation period #1"
            options={reservationPeriodOptions}
            value={timeRule.reservationPeriod1}
            onChange={(value) => onChange({ key: 'reservationPeriod1', value })}
            data-testid="reservation-period-1"
          />
          <TEInput.HoursMinuteInput
            label="Reservation length #1"
            tooltip="Reservation length #1"
            value={secondToHourMinute(timeRule.reservationLength1)}
            onChange={(val) =>
              onChange({
                key: 'reservationLength1',
                value: hourMinuteToSecond(val),
              })
            }
            minuteStep={5}
            className="reservation-length-1"
          />
          <TEInput.InputNumber
            label="Reservation count #1"
            tooltip="Reservation count #1"
            value={timeRule.reservationCount1}
            onChange={(value) => onChange({ key: 'reservationCount1', value })}
            data-testid="reservation-count-1"
          />
        </Space>
        <Space direction="vertical">
          <TEInput.Select
            label="Reservation period #2"
            tooltip="Reservation period #2"
            options={reservationPeriodOptions}
            value={timeRule.reservationPeriod2}
            onChange={(value) => onChange({ key: 'reservationPeriod2', value })}
            data-testid="reservation-period-2"
          />
          <TEInput.HoursMinuteInput
            label="Reservation length #2"
            tooltip="Reservation length #2"
            value={secondToHourMinute(timeRule.reservationLength2)}
            onChange={(val) =>
              onChange({
                key: 'reservationLength2',
                value: hourMinuteToSecond(val),
              })
            }
            minuteStep={5}
            className="reservation-length-2"
          />
          <TEInput.InputNumber
            label="Reservation count #2"
            tooltip="Reservation count #2"
            value={timeRule.reservationCount2}
            onChange={(value) => onChange({ key: 'reservationCount2', value })}
            data-testid="reservation-count-2"
          />
          <div className="use-modified">
            <TEInput.Checkbox
              label="Use modified by when calculating user quota"
              tooltip="Use modified by when calculating user quota"
              checked={timeRule.useModifiedByWhenCalculatingUserQuota}
              onChange={(e) =>
                onChange({
                  key: 'useModifiedByWhenCalculatingUserQuota',
                  value: e.target.checked,
                })
              }
              data-testid="use-modified"
            />
          </div>
        </Space>
      </div>
    </TEDrawerSection>
  );
};

export default ReservationPeriod;

const reservationPeriodOptions = Object.keys(EReservationPeriodType).map(
  (key) => ({
    value: key,
    label: key,
  })
);
